// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'analytics-bad-solid';

export const Component = () => (
  <path d='M20.93 20.93c-2.395 2.394-5.268 3.592-8.67 3.592-3.4 0-6.273-1.198-8.668-3.592C1.198 18.535 0 15.662 0 12.26a12.6 12.6 0 0 1 .623-3.879l.096.096 5.172 5.125c.24.239.432.239.67 0l3.64-3.593 6.658 6.657h-6.657c-.336 0-.527.144-.527.48 0 .382.191.574.527.574h7.806c.047.048.144 0 .287-.047.144-.048.24-.192.288-.335.047-.048.047-.144.047-.288V9.34c0-.384-.143-.576-.478-.576-.336 0-.48.191-.48.575v6.657l-7.135-7.088c-.24-.24-.48-.24-.719 0L6.226 12.5 1.053 7.376c.91-2.203 2.395-3.975 4.454-5.364C7.519.672 9.77 0 12.26 0c3.4 0 6.274 1.198 8.669 3.592 2.394 2.395 3.592 5.268 3.592 8.669 0 3.4-1.198 6.274-3.592 8.669Z' />
);

export const viewBox = '0 0 25 25';
